import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxShimmerLoadingComponent } from './ngx-shimmer-loading.component';

@NgModule({
  declarations: [NgxShimmerLoadingComponent],
  imports: [CommonModule],
  exports: [NgxShimmerLoadingComponent],
})
export class NgxShimmerLoadingModule {}
